'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bulletin-realtor', {
      url: '/realtor/bulletin',
      template: '<bulletin-realtor></bulletin-realtor>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/bulletin/list/realtor/bulletin-realtor.routes.js